import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { CreateTaxRateInput, StripeTaxRate } from "./types";
import { CATALOG_TAX_RATES_QUERY_KEY } from "./use-tax-rates-list";

async function createTaxRate(input: CreateTaxRateInput): Promise<StripeTaxRate> {
  return httpClient<StripeTaxRate>("/api/admin/catalog/tax-rates", {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(input),
  });
}

export function useCreateTaxRate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createTaxRate,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CATALOG_TAX_RATES_QUERY_KEY });
    },
  });
}
